import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type { UseTeamMemberListParams } from './types';

export type ConfirmTeamMemberUploadRequestBody = {
  token: string;
};

export const useConfirmTeamMemberUpload: MutationFunction<
  string, // no response body, reads as an empty string
  ConfirmTeamMemberUploadRequestBody,
  [UseTeamMemberListParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (body) => {
      return request(`/suppliers/${params.locator}/members_upload/confirm`, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['groups', 'teamMembers', 'confirmUpload'],
  });
};
